import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/ssoapi/sysuseratt/login',
    method: 'post',
    params: data,
  })
}

// 文件上传接口
export function updateImg(data) {
  return request({
    url: '/ssoapi/sysuseratt/upload',
    method: 'post',
    data: data
  })
}

// 验证码登录
export function loginCode(data) {
  return request({
    url: '/transapi/info/loginCode',
    method: 'post',
    data: data,
  })
}
// 密码登录
export function loginPwd(data) {
  return request({
    url: '/transapi/info/loginPwd',
    method: 'post',
    data: data,
  })
}
// 发送验证码
export function sendCode(data) {
  return request({
    url: '/transapi/info/sendCode',
    method: 'post',
    data: data,
  })
}
// .设置密码
export function setPassword(data) {
  return request({
    url: '/transapi/acc/setPassword',
    method: 'post',
    data: data,
  })
}
// 修改密码发送验证码
export function modifyPwdSendCode(data) {
  return request({
    url: '/transapi/info/modifyPwdSendCode',
    method: 'post',
    data: data,
  })
}
// 修改密码-检查验证码
export function modifyPwdCheck(data) {
  return request({
    url: '/transapi/info/modifyPwdCheck',
    method: 'post',
    data: data,
  })
}
// 修改密码-检查验证码
export function getImageCode(data) {
  return request({
    url: '/transapi/info/getImageCode',
    method: 'post',
    data: data,
  })
}



/**  用户管理模块  **/
// 获取用户信息
export function getUserInfo(data) {
  return request({
    url: '/transapi/acc/getUserInfo',
    method: 'post',
    data: data,
  })
}
// 发送短信验证码
export function sendMessageCode(data) {
  return request({
    url: '/transapi/acc/sendMessageCode',
    method: 'post',
    data: data,
  })
}
// 校验老的短信
export function checkOldMessage(data) {
  return request({
    url: '/transapi/acc/checkOldMessage',
    method: 'post',
    data: data,
  })
}
// 新的账号发送短信
export function snedNewMessage(data) {
  return request({
    url: '/transapi/acc/snedNewMessage',
    method: 'post',
    data: data,
  })
}
// 校验新的短信并且修改手机号
export function checkNewAndUpdate(data) {
  return request({
    url: '/transapi/acc/checkNewAndUpdate',
    method: 'post',
    data: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js